// A single PLZ token: exact code ('38124'), range ('38100-38200') or prefix
// wildcard ('38*', '381*'). Mirrors the backend token grammar so the UI can
// validate before submitting and the search param stays a plain string.
const POSTAL_TOKEN_PATTERN = /^(?:\d{5}|\d{5}-\d{5}|\d{1,5}\*)$/;

/**
 * Split a free-text PLZ list into trimmed non-empty tokens.
 * @param {string} value - Comma/whitespace-separated codes/ranges/wildcards
 * @returns {string[]}
 */
export const splitPostalTokens = (value) => (value || '').split(/[\s,]+/).filter(Boolean);

/**
 * Validate a free-text PLZ list. A range token additionally requires from <= to.
 * @param {string} value - Comma/whitespace-separated codes/ranges/wildcards
 * @returns {{ valid: boolean, invalid: string[] }}
 */
export const validatePostalList = (value) => {
	const invalid = [];
	for (const token of splitPostalTokens(value)) {
		if (!POSTAL_TOKEN_PATTERN.test(token)) {
			invalid.push(token);
			continue;
		}
		const range = token.match(/^(\d{5})-(\d{5})$/);
		if (range && parseInt(range[1], 10) > parseInt(range[2], 10)) invalid.push(token);
	}
	return { valid: invalid.length === 0, invalid };
};

/**
 * Whether the PLZ criterion (from/to range and/or free-text list) carries any
 * usable segment.
 * @param {object} filters - UI filter state
 * @returns {boolean}
 */
export const hasPostalInput = (filters) =>
	Boolean(filters.plzFrom && filters.plzTo) || splitPostalTokens(filters.plzList).length > 0;
